import { render, staticRenderFns } from "./TextAreaItem.vue?vue&type=template&id=278c3942&scoped=true&"
import script from "./TextAreaItem.vue?vue&type=script&lang=js&"
export * from "./TextAreaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c3942",
  null
  
)

export default component.exports